// Content language choices (decision D37.3). Each language is named in its own language by the browser
// (Intl.DisplayNames), as in a locale switcher; the API accepts any BCP-47 tag, so a current value outside the suggested
// list is still offered as itself.
import { SUGGESTED_CONTENT_LANGUAGES } from "@maestros/contracts";

export interface LanguageChoice {
  tag: string;
  label: string;
}

/** The tag named in its own language with the tag, e.g. "Deutsch (de)"; the bare tag when the runtime cannot name it. */
export function contentLanguageLabel(tag: string): string {
  try {
    const name = new Intl.DisplayNames([tag], { type: "language" }).of(tag);
    if (name && name !== tag) return `${name.charAt(0).toLocaleUpperCase(tag)}${name.slice(1)} (${tag})`;
  } catch {
    // An invalid or unknown tag: shown as is.
  }
  return tag;
}

/** The selector's options: the suggested languages, plus `current` when it is another valid tag. */
export function contentLanguageChoices(current?: string | null): LanguageChoice[] {
  const tags: string[] = [...SUGGESTED_CONTENT_LANGUAGES];
  if (current && !tags.includes(current)) tags.push(current);
  return tags.map((tag) => ({ tag, label: contentLanguageLabel(tag) }));
}
